import { SpentFormatter } from 'components/tables/NinjaTable/formatters';
import RoiFormatter from 'components/tables/NinjaTable/formatters/RoiFormatter';
import RoasFormatter from 'components/tables/NinjaTable/formatters/RoasFormatter';
import ValueDotFormatter from 'components/tables/NinjaTable/formatters/ValueDotFormatter';

import { Select } from 'antd';

export const metricsList = {
  ad_spent: {
    color: '#eb2f20',
    name: 'Ad Spent',
    formatter: SpentFormatter,
    show: true,
    type: 'bar',
  },
  net_profit: {
    color: '#91c716',
    name: 'Net Profit',
    valueFormatter: ValueDotFormatter,
    show: true,
    type: 'bar',
  },
  gross_profit: {
    color: '#536A8B',
    name: 'Gross Profit',
    valueFormatter: ValueDotFormatter,
    type: 'bar',
  },
  gross_income: {
    color: '#ffbb02',
    name: 'Gross Income',
    valueFormatter: ValueDotFormatter,
    type: 'bar',
  },
  roi: { color: '#ff4e00', name: 'ROI', type: 'line', formatter: RoiFormatter, opacity: 0.7 },
  roas: { color: '#F09319', name: 'ROAS', type: 'line', formatter: RoasFormatter, opacity: 0.7 },
};

export const MetricsSelect = (props, { value, onChange }) => {
  const { Option } = Select;
  return (
    <Select
      style={{ width: 200 }}
      value={value}
      onChange={onChange}
      placeholder='Select a metric'
      {...props}
    >
      {Object.entries(metricsList).map(([key, metric]) => (
        <Option key={key} value={key}>
          {metric.name}
        </Option>
      ))}
    </Select>
  );
};
